import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardDataState, generateCacheKey } from './dashboard.state';
import { DashboardFilterDTO } from '../../dto/dashboard/dashboard.dto';

export const selectDashboardState = createFeatureSelector<DashboardDataState>('dashboard');

export const selectWidgetData = (widgetType: string, dataSource: string, filters?: DashboardFilterDTO) => 
  createSelector(
    selectDashboardState,
    (state) => {
      const cacheKey = generateCacheKey(widgetType, dataSource, filters);
      return state.widgetData[cacheKey]?.data;
    }
  );

export const selectWidgetDataLoading = (widgetType: string, dataSource: string, filters?: DashboardFilterDTO) => 
  createSelector(
    selectDashboardState,
    (state) => {
      const cacheKey = generateCacheKey(widgetType, dataSource, filters);
      return state.widgetData[cacheKey]?.loading || false;
    }
  );

export const selectWidgetDataError = (widgetType: string, dataSource: string, filters?: DashboardFilterDTO) => 
  createSelector(
    selectDashboardState,
    (state) => {
      const cacheKey = generateCacheKey(widgetType, dataSource, filters);
      return state.widgetData[cacheKey]?.error;
    }
  );

export const selectWidgetDataLastUpdated = (widgetType: string, dataSource: string, filters?: DashboardFilterDTO) => 
  createSelector(
    selectDashboardState,
    (state) => {
      const cacheKey = generateCacheKey(widgetType, dataSource, filters);
      return state.widgetData[cacheKey]?.lastUpdated;
    }
  );

// User-specific widget configuration selectors
export const selectCurrentUserId = createSelector(
  selectDashboardState,
  (state) => state.currentUserId
);

export const selectUserWidgetConfigs = (userId: string) => 
  createSelector(
    selectDashboardState,
    (state) => state.userWidgetConfigs[userId] || {}
  );

export const selectUserWidgetConfig = (userId: string, widgetId: string) => 
  createSelector(
    selectUserWidgetConfigs(userId),
    (configs) => configs[widgetId]
  );

export const selectWidgetSettings = (userId: string, widgetId: string) => 
  createSelector(
    selectUserWidgetConfig(userId, widgetId),
    (config) => config?.settings
  );

export const selectWidgetPosition = (userId: string, widgetId: string) => 
  createSelector(
    selectUserWidgetConfig(userId, widgetId),
    (config) => config?.position
  ); 